import React from "react";
import { ThumbsUp, ThumbsDown } from "lucide-react";

const MessageRating = ({ messageIndex, ratedMessages, handleRateMessage }) => {
  return (
    <div
      className="flex items-center gap-2 absolute -top-8 right-2 bg-white rounded-full py-1.5 px-2.5 opacity-0 transition-opacity duration-200 group-hover:opacity-100 hover:opacity-100"
      style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.12)', border: '1px solid #E5E7EB' }}
    >
      <ThumbsUp
        size={15}
        aria-label="Rate message helpful"
        className={`cursor-pointer transition-all duration-200 hover:scale-110 ${ratedMessages[messageIndex] === 'good' ? 'text-green-500' : 'text-gray-400'} ${ratedMessages[messageIndex] === 'bad' ? 'opacity-40 cursor-default' : 'hover:text-green-500'}`}
        onClick={() => handleRateMessage(messageIndex, true)}
      />
      <ThumbsDown
        size={15}
        aria-label="Rate message unhelpful"
        className={`cursor-pointer transition-all duration-200 hover:scale-110 ${ratedMessages[messageIndex] === 'bad' ? 'text-red-500' : 'text-gray-400'} ${ratedMessages[messageIndex] === 'good' ? 'opacity-40 cursor-default' : 'hover:text-red-500'}`}
        onClick={() => handleRateMessage(messageIndex, false)}
      />
    </div>
  );
};

export default MessageRating;